module.exports = __webpack_public_path__ + "img/notification-view.ffdf10a9.png";